export const routerFuture = {
  v7_relativeSplatPath: true,
  v7_startTransition: true,
};
